export default __webpack_public_path__ + "static/media/urban-light-cdc.ecf8b368.png";